import { InferType, array, date, mixed, object, string } from "yup";

export const taskStateAuditLogEntrySchema = object({
  id: string().uuid().required(),
  occurredAt: date().required(),
  action: string().oneOf(["INSERT", "UPDATE", "DELETE"]).required(),
  actorType: string().oneOf(["user", "integration", "system"]).nullable(),
  actorUserId: string().uuid().nullable(),
  actorIntegrationId: string().nullable(),
  onBehalfOfUserId: string().uuid().nullable(),
  changes: mixed().required(),
});

export type TaskStateAuditLogEntry = InferType<
  typeof taskStateAuditLogEntrySchema
>;

export const taskStateAuditLogEntriesSchema = array().of(
  taskStateAuditLogEntrySchema
);

export type TaskStateAuditLogEntries = InferType<
  typeof taskStateAuditLogEntriesSchema
>;
